import { render, staticRenderFns } from "./paginationControlls.vue?vue&type=template&id=db50421a&"
import script from "./paginationControlls.vue?vue&type=script&lang=js&"
export * from "./paginationControlls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports